import { sortBy } from 'lodash';
import { Actions, ActionTypes } from '../actions/traffic-steering-configuration.action';
import {
  TrafficSteering,
  TrafficSteeringConfigurationReducer,
} from '../models/traffic-steering-configuration.model';

export const initialState: TrafficSteeringConfigurationReducer = {
  id: 0,
  deviceId: 0,
  isDeviceLevelTrafficSteeringEnabled: true,
  traffic_steering: [],
  userIds: [],
  groupIds: [],
};

function getUserAndGroupIdsConfiguredInTs(trafficSteering: TrafficSteering[]) {
  const userIds = trafficSteering.map((ts) => ts.source_user).filter(Boolean);

  const groupIds = trafficSteering
    .flatMap((ts) => [ts.source_group, ts.destination_group])
    .filter(Boolean);

  return {
    userIds: [...new Set(userIds)],
    groupIds: [...new Set(groupIds)],
  };
}

export function trafficSteeringReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_TRAFFIC_STEERING_CONFIGURATION_BY_ID: {
      const trafficSteering = action.payload.traffic_steering;
      const { userIds, groupIds } = getUserAndGroupIdsConfiguredInTs(trafficSteering);

      return {
        ...state,
        id: action.payload.id,
        deviceId: action.payload.device_id,
        traffic_steering: trafficSteering,
        userIds,
        groupIds,
        isDeviceLevelTrafficSteeringEnabled: action.payload.enable_traffic_steering,
      };
    }

    case ActionTypes.ADD_TRAFFIC_STEERING_CONFIGURATION: {
      const newStateAdd = { ...state };
      const newConfiguration = action.payload.configuration;
      newConfiguration.order = newStateAdd.traffic_steering.length + 1;
      newStateAdd.traffic_steering.push(newConfiguration);

      const { userIds, groupIds } = getUserAndGroupIdsConfiguredInTs(newStateAdd.traffic_steering);
      newStateAdd.userIds = userIds;
      newStateAdd.groupIds = groupIds;

      return {
        ...newStateAdd,
      };
    }

    case ActionTypes.EDIT_TRAFFIC_STEERING_CONFIGURATION: {
      const newStateEdit = { ...state };
      const deviceConfigurations = state.traffic_steering;
      const configurationIndex = deviceConfigurations.findIndex(
        (c) => c.id === action.payload.configuration.id
      );
      newStateEdit.traffic_steering[configurationIndex] = {
        order: newStateEdit.traffic_steering[configurationIndex]['order'],
        ...action.payload.configuration,
      };

      const { userIds, groupIds } = getUserAndGroupIdsConfiguredInTs(newStateEdit.traffic_steering);
      newStateEdit.userIds = userIds;
      newStateEdit.groupIds = groupIds;

      return {
        ...newStateEdit,
      };
    }

    case ActionTypes.DELETE_TRAFFIC_STEERING_CONFIGURATION: {
      const newStateDelete = { ...state };
      const filteredDeviceConfiguration = newStateDelete.traffic_steering.filter(
        (c) => action.payload.configuration_ids.indexOf(c.id) === -1
      );
      filteredDeviceConfiguration.forEach((a, i) => (a.order = i + 1));

      const { userIds, groupIds } = getUserAndGroupIdsConfiguredInTs(filteredDeviceConfiguration);

      return {
        ...state,
        traffic_steering: filteredDeviceConfiguration,
        userIds,
        groupIds,
      };
    }

    case ActionTypes.CLEAR_CURRENT_TRAFFIC_STEERING_CONFIGURATION:
      return {
        ...state,
        id: 0,
        deviceId: 0,
        traffic_steering: [],
        userIds: [],
        groupIds: [],
      };

    case ActionTypes.REORDER_TRAFFIC_STEERING_CONFIGURATION:
      const newStateReorder = { ...state };
      const currentTrafficSteering = newStateReorder.traffic_steering.filter(
        (a) => a.id === action.payload.trafficSteeringId
      );
      const filteredTrafficSteering = newStateReorder.traffic_steering.filter(
        (a) => a.id !== action.payload.trafficSteeringId
      );

      filteredTrafficSteering.forEach((a, i) => (a.order = i + 1));
      filteredTrafficSteering.splice(action.payload.newOrder - 1, 0, currentTrafficSteering[0]);
      filteredTrafficSteering.forEach((a, i) => (a.order = i + 1));
      const sortedTrafficSteering = sortBy(filteredTrafficSteering, 'order');

      return {
        ...state,
        traffic_steering: sortedTrafficSteering,
      };

    case ActionTypes.SET_TRAFFIC_STEERING_CONFIG_LEVEL_ENABLED_STATE:
      const updatedTrafficSteering = state.traffic_steering.map((trafficSteering) =>
        trafficSteering.id === action.payload.trafficSteeringData.id
          ? { ...trafficSteering, is_configuration_enabled: action.payload.isEnabled }
          : trafficSteering
      );
      return {
        ...state,
        traffic_steering: updatedTrafficSteering,
      };

    case ActionTypes.SET_TRAFFIC_STEERING_DEVICE_LEVEL_ENABLED_STATE:
      return {
        ...state,
        isDeviceLevelTrafficSteeringEnabled: action.payload,
      };

    default:
      return state;
  }
}
